import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getManagementList as getManagementListApi,
	getManagement as getManagementApi,
	addNewManagement as addNewManagementApi,
	updateManagement as updateManagementApi,
	deleteManagement as deleteManagementApi,
	getOrganizationalChart as getOrganizationalChartApi
} from '../../helpers/establishment/backend_helper';

export const getManagementList = createAsyncThunk('managements/getManagementList', async () => {
	try {
		const response = getManagementListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getManagement = createAsyncThunk('managements/getManagement', async management_id => {
	try {
		const response = getManagementApi(management_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewManagement = createAsyncThunk('managements/addNewManagement', async management => {
	try {
		const response = addNewManagementApi(management);
		toast.success('Departamento agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar management.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateManagement = createAsyncThunk('managements/updateManagement', async (management) => {
		try {
			const response = updateManagementApi(management);
			toast.success('Departamento actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar management.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteManagement = createAsyncThunk('managements/deleteManagement', async management => {
	try {
		const response = await deleteManagementApi(management);
		toast.success('Departamento eliminado exitosamente.', { autoClose: 3000 });
		return { management, ...response };
	} catch (error) {
		toast.error('Error al eliminar management.', { autoClose: 3000 });
		throw new Error(error);
	}
});



export const getOrganizationalChart = createAsyncThunk('managements/getOrganizationalChart', async () => {
	try {
		const response = getOrganizationalChartApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});
